import Reveal from "@/components/Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "¿Necesito conocimientos previos de neuromarketing o marketing?",
    a: "No. El curso empieza desde cero y está diseñado para ser accesible. Si en algún momento se necesita una lectura o material previo a una sesión, se avisa con anticipación, pero nada avanzado.",
  },
  {
    q: "¿Recibo certificado?",
    a: "Sí. Al completar las tres sesiones recibís un certificado de participación.",
  },
  {
    q: "¿Qué pasa si no puedo asistir a una sesión?",
    a: "Las sesiones se graban. Si faltás a una, vas a tener acceso a la grabación para ponerte al día antes de la siguiente.",
  },
  {
    q: "¿Necesito tener una marca para participar?",
    a: "No. Si tenés marca, trabajás sobre ella. Si no, practicás con las marcas de tus compañeros y con casos reales que se trabajan durante el curso.",
  },
  {
    q: "¿Qué necesito para participar?",
    a: "Una computadora o celular con conexión a internet, micrófono y cámara. La plataforma se confirma antes del inicio del curso.",
  },
  {
    q: "¿Cómo funciona el pago?",
    a: "Completás el formulario de inscripción y te contactamos con los datos de pago. Podés pagar por QR / transferencia bancaria (Paraguay) o PayPal (internacional).",
  },
  {
    q: "¿Puedo hablar con vos antes de inscribirme?",
    a: "Sí. Escribime por WhatsApp o Instagram y te respondo cualquier duda.",
  },
];

const Faq = () => (
  <section className="relative border-t border-white/10 bg-black/30 py-20 md:py-28" data-testid="faq-section">
    <div className="mx-auto max-w-3xl px-6 md:px-12">
      <Reveal className="mb-10 text-center">
        <p className="mb-4 text-xs font-medium uppercase tracking-[0.35em] text-neoncyan">
          Resolvemos tus dudas
        </p>
        <h2 className="font-display text-3xl font-black uppercase tracking-tighter md:text-4xl">
          Preguntas <span className="text-magenta">frecuentes</span>
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`faq-${i}`}
              className="border-white/10"
              data-testid={`faq-item-${i + 1}`}
            >
              <AccordionTrigger
                className="py-4 text-left text-sm font-bold text-rosewhite transition-colors duration-300 hover:text-neoncyan hover:no-underline md:text-base"
                data-testid={`faq-trigger-${i + 1}`}
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent
                className="text-sm leading-relaxed text-lilac/85"
                data-testid={`faq-content-${i + 1}`}
              >
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);

export default Faq;
